import React, {ReactNode} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from "@mui/material";
import {_transl} from "../../store/localization/TranslMessasge";
import {CommonTranslationKey} from "../../pages/main/content/CommonTranslationKey";

export interface ConfirmationDialogProps {
    open: boolean;
    title: string;
    message: string;
    children?: ReactNode;
    confirmButtonLabel: string;
    confirmDisabled?: boolean;
    dismissButtonLabel?: string;
    destructive?: boolean;
    onConfirm: () => void;
    onDismiss: () => void;
    modal?: boolean;
}

export default function ConfirmationDialog(props: ConfirmationDialogProps) {
    const {open, title, message, children, confirmButtonLabel, confirmDisabled = false, dismissButtonLabel = _transl(CommonTranslationKey.CANCEL), destructive = false, onConfirm, onDismiss, modal = false} = props;

    const handleClose = (_event: object, reason: "backdropClick" | "escapeKeyDown") => {
        if (modal && reason) {
            return;
        }
        onDismiss();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="confirmation-dialog-title"
            aria-describedby="confirmation-dialog-description"
        >
            <DialogTitle id="confirmation-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="confirmation-dialog-description">
                    {message}
                </DialogContentText>
                {children}
            </DialogContent>
            <DialogActions sx={{px: 3, pb: 2}}>
                <Button onClick={onDismiss} variant="outlined">
                    {dismissButtonLabel}
                </Button>
                <Button
                    onClick={onConfirm}
                    color={destructive ? "error" : "primary"}
                    variant="contained"
                    autoFocus={!destructive}
                    disabled={confirmDisabled}
                >
                    {confirmButtonLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
}